import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
function ChatScreen() {
    const [input,setinput]=useState([''])
    const [messages, setmessage] = useState([
        {
            name: "gunjan",
            image: "https://i.ytimg.com/vi/DJKxTZbsEbM/hqdefault.jpg",
            message: "hei!!!!  ",
        },
        {
            name: "gunjan",
            image: "https://i.ytimg.com/vi/DJKxTZbsEbM/hqdefault.jpg",
            message: "reply",
        },
        {
            message: "hei , how are you?",
        },
    ]);
    const handleSend=(e)=>{
        e.preventDefault();
        setmessage([...messages,{message : input} ]);
        setinput("");
    }
    return (
        <div className="chatScreen">
            <p className="chatScreen_timespan">
                YOU MATCHED WITH GUNJAN ON 10/2/21
            </p>
            {messages.map((message) =>
                message.name ? (
                    <div className="chatScreen_message">
                        <Avatar className="chatScreen_image"
                            alt={message.name}
                            src={message.image}
                        />
                        <p className="chatScreen_text">{message.message}</p>
                        </div>
                ):(
                        <div className="chatScreen_message">
                            <p className="chatScreen_useText">
                                {message.message}
                            </p>
                        </div>
                )

                   
                )}
                <div>
                    <form  className="chatScreen_input">
                        <input 
                        type="text"
                         className="chatScreen_inputfield"
                          placeholder="Type a message....."
                          value={input}
                          onChange={(e)=>setinput(e.target.value) }
                          />
                        <button 
                        className="chatScreen_inputButton"
                        onClick={handleSend}
                        > SEND</button>
                    </form>
                </div>
        </div>
    );
}


export default ChatScreen; 